import ApiService from '../services/apiService';

const indexHealthPrevisionsRequest = ({ dispatch, params = {}, failureCallback, successCallback }) =>
  ApiService.request('get', '/health_previsions', {
    dispatch,
    params,
    failureCallback,
    successCallback
  });

export default indexHealthPrevisionsRequest;
